import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import {
  PaginationHeaderYear,
  BODY_CUENTAS,
  GET_SUM_T_PAGO,
} from "./../../Constants/Util";
import classnames from "classnames";
import {
  ModalSaved,
  ModalListaPersonConta,
  ModalAddCXC,
} from "./../../Constants/Modal";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  Row,
  Col,
  Label,
  Container,
  FormGroup,
  Input,
  Button,
  ButtonGroup,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  DropdownToggle, Dropdown, DropdownItem, DropdownMenu
} from "reactstrap";
import {
  getRPagoDetail,
  getTpago,
  getPersonByCedulaRPago,
  postRP_rpago,
  postRPagoDetail,
  deleteRpd,
  getcxc_cobrar,
  getPersonListByGradeByYear,
  getGrades,
  getMonto,
  getCxcDetail,
  getCxc,
  update_stado_matricula,
  update_stado_mensualidad,
  update_stado_morosidad,
} from "../../Constants/Services";
import {
  IRDPago,
  ITPago,
  IRegistrarPago,
  IPersonSelect,
  IGrades,
  IMonto,
  IFormMatricula2,
  ICxcDetail,
  IMontoDate,
  IDropDates,
  Icxc_cobrar,
} from "./../../Constants/Interfaces";

interface ICuentasState {
  dataCxcDetail: ICxcDetail[];
  dataPerson: IPersonSelect[];
  dataRPagoD: IRDPago[];
  dataFormRPagoD: IRDPago;
  dataRPago: IRegistrarPago[];
  dataFormRPago: IRegistrarPago;
  cxc_cobrar: Icxc_cobrar[];
  dataFCxC: {
    cxc_id: string;
    cxc_stado: string;
  };
  dataFGrade: {
    gr_id: string;
    gr_alias: string;
    gr_desc: string;
  };
  dataGrades: IGrades[];
  dataTPago: ITPago[];
  msg_error: string;
  msg_error2: string;
  msg_error3: string;
  isOpenDropdown: boolean;
  loading: boolean;
  isOpenModalSaved: boolean;
  isOpenModalLista: boolean;
  year: string;
  activeTab: string;
  formMonto: IMonto;
  formMatricula: IFormMatricula2;
  isOpenDetailCuentas: boolean;
  dataMontoDate: IMontoDate[];
  dropDates: IDropDates[];
  isOpenModalAddCxC: boolean;
  t_pago: string;
  rpd_cxc: string;
}

class Rpagos extends Component<RouteComponentProps<{}>, ICuentasState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dropDates: [],
      rpd_cxc: "",
      dataMontoDate: [],
      dataGrades: [],
      dataPerson: [],
      dataRPagoD: [],
      dataRPago: [],
      dataCxcDetail: [],
      dataFCxC: {
        cxc_id: "",
        cxc_stado: "",
      },
      cxc_cobrar: [],
      activeTab: "1",
      dataFormRPago: {
        num_f: "",
        per_id: "",
        per_cedula: "",
        per_name: "",
        rp_metodop: "",
        rp_pagoTotal: "",
        rp_referencia: "",
        rp_fechapago: new Date().toString(),
        reg_id: "",
      },
      formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
        cxcr_debep: "",
        per_cedula:"",
        reg_grade:""
      },
      formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_laboratorio: "",
        mt_a_efisica: "",
        t_status: "",
        mt_robotica:"",
        mt_a_robotica:""
      },
      dataFGrade: {
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
      },
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        rpd_secuencia:"",
        rpd_cxc:"",
        tp_desc: "",
      },
      dataTPago: [],
      msg_error: "",
      msg_error2: "",
      msg_error3: "",
      isOpenDropdown: false,
      loading: false,
      isOpenModalSaved: false,
      isOpenModalLista: false,
      year: new Date().getFullYear().toString(),
      isOpenDetailCuentas: false,
      t_pago: "",
      isOpenModalAddCxC: false,
    };

    this.saveRpago = this.saveRpago.bind(this);
    this.getTPago = this.getTPago.bind(this);
    this.onChangeRPago = this.onChangeRPago.bind(this);
    this.handlerSearchPerson = this.handlerSearchPerson.bind(this);
    this.setMetodoPago = this.setMetodoPago.bind(this);
    this.onChangeDatePicker = this.onChangeDatePicker.bind(this);
    this.setTpago = this.setTpago.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.SaveRP_rpagoDetail = this.SaveRP_rpagoDetail.bind(this);
    this.handlerModalSaved = this.handlerModalSaved.bind(this);
    this.cancelRpago = this.cancelRpago.bind(this);
    this.handlerOpenLista = this.handlerOpenLista.bind(this);
    this.setPerson = this.setPerson.bind(this);
    this.handlerSetPerson = this.handlerSetPerson.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.fetchGradeAsig = this.fetchGradeAsig.bind(this);
    this.setGroup = this.setGroup.bind(this);
    this.handlerActiveTab = this.handlerActiveTab.bind(this);
    this.onChangeData = this.onChangeData.bind(this);
    this.setDataEstado = this.setDataEstado.bind(this);
    this.handlerSearchCuenta = this.handlerSearchCuenta.bind(this);
    this.fetcCxcDetail = this.fetcCxcDetail.bind(this);
    this.fetchMonto = this.fetchMonto.bind(this);
    this.fetchcxc_cobrar = this.fetchcxc_cobrar.bind(this);
    this.setDataEstadoMatricula = this.setDataEstadoMatricula.bind(this);
    this.setDataEstadoMensualidad = this.setDataEstadoMensualidad.bind(this);
    this.setMorosidad = this.setMorosidad.bind(this);
    this.addPaymentCxc = this.addPaymentCxc.bind(this);
    this.modalAddPayment = this.modalAddPayment.bind(this);
    this.onChangeRPagoCedula = this.onChangeRPagoCedula.bind(this);
    this.onChangeRPagoRef = this.onChangeRPagoRef.bind(this);
  }

  async fetchcxc_cobrar(reg_id: string) {
    const response = await getcxc_cobrar(reg_id, this.state.year);
    this.setState({
      cxc_cobrar: response,
      loading: false,
      msg_error: "",
    });
  }

  handlerSearchCuenta = (reg_id: any) => {
    // this.setState((prevState) => ({
    //   isOpenDetailCuentas: !prevState.isOpenDetailCuentas,
    //   formMatricula: {
    //     cxcr_id: "",
    //     cxcr_registration: "",
    //     cxcr_tcuenta: "",
    //     cxcr_matricula: "",
    //     cxcr_mensualidad: "",
    //     cxcr_stado: "",
    //     cxcr_saldo: "",
    //     cxcr_status: "",
    //     cxcr_date: "",
    //     cxcr_anualidad: "",
    //     cxcr_s_anualidad: "",
    //     cxcr_saldo_cole: "",
    //     cxcr_anualidad_state: "",
    //     mtd_id: "",
    //     mtd_mes_number: "",
    //     cxcr_debep: "",
    //     per_cedula:""
    //   },
    //   dataCxcDetail: [],
    //   dataMontoDate: [],
    //   dropDates: [],
    // }));
    this.fetchCxc(reg_id);
  };

  async fetchCxc(reg_id: string) {
    const response = await getCxc(reg_id, this.state.year);
    if (response[0] !== undefined) {
      this.setState({
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_id: response[0].cxcr_id,
          cxcr_registration: response[0].cxcr_registration,
          cxcr_tcuenta: response[0].cxcr_tcuenta,
          cxcr_stado: response[0].cxcr_stado,
          cxcr_saldo: response[0].cxcr_saldo,
          cxcr_status: response[0].cxcr_status,
          cxcr_date: response[0].cxcr_date,
          cxcr_anualidad: response[0].cxcr_anualidad,
          cxcr_saldo_cole: response[0].cxcr_saldo_cole,
          cxcr_anualidad_state: response[0].cxcr_anualidad_state,
          cxcr_debep: response[0].cxcr_debep,
        },
        loading: false,
        msg_error: "",
      });
      this.fetcCxcDetail(response[0].cxcr_id);
      this.fetchMonto({ gr_id: this.state.dataFGrade.gr_id });
      this.fetchcxc_cobrar(reg_id);
    } else {
      this.setState({
        msg_error: "El estudiante no esta registrado en cuentas",
      });
    }
  }

  async fetchMonto({ gr_id }) {
    const response = await getMonto(gr_id, this.state.year);
    var matricula = "";
    var mensualidad = "";
    var anualidad = "";
    if (response.mt !== undefined && response.mtd !== undefined) {
      if (this.state.formMatricula.cxcr_tcuenta === "3") {
        matricula = response.mt[0].mt_matricula_hd;
        mensualidad = response.mt[0].mt_mensualidad_hd;
        anualidad = response.mt[0].mt_mensualidad_hd;
      } else if (this.state.formMatricula.cxcr_tcuenta === "2") {
        matricula = response.mt[0].mt_matricula_hm;
        mensualidad = response.mt[0].mt_mensualidad_hm;
        anualidad = response.mt[0].mt_anualidad_hm;
      } else {
        matricula = response.mt[0].mt_matricula_r;
        mensualidad = response.mt[0].mt_mensualidad_r;
        anualidad = response.mt[0].mt_anualidad_r;
      }

      this.setState({
        formMonto: response.mt[0],
        dataMontoDate: response.mtd,
        dropDates: response.m_dates,
        formMatricula: {
          ...this.state.formMatricula,
          cxcr_matricula: matricula,
          cxcr_mensualidad: mensualidad,
          cxcr_s_anualidad: anualidad,
        },
        // msg_error: "",
      });
    } else {
      this.setState({
        dataMontoDate: [],
        // formMonto: {
        //   mt_id: "",
        //   mt_grade: "",
        //   mt_year: "",
        //   mt_mensualidad_r: "",
        //   mt_mensualidad_hm: "",
        //   mt_mensualidad_hd: "",
        //   mt_matricula_r: "",
        //   mt_matricula_hm: "",
        //   mt_matricula_hd: "",
        //   mt_plataforma: "",
        //   mt_laboratorio: "",
        //   mt_efisica: "",
        //   mt_otro_monto: "",
        //   mt_otro_desc: "",
        //   mt_anualidad_r: "",
        //   mt_anualidad_hm: "",
        //   mt_anualidad_hd: "",
        //   mt_a_plataforma: "",
        //   mt_a_laboratorio: "",
        //   mt_a_efisica: "",
        //   t_status: "",
        // },
        msg_error:
          "No tienes montos o fechas de mensualidades registrados en este grado",
      });
    }
  }

  async fetcCxcDetail(cxcr_id: string) {
    const response = await getCxcDetail(cxcr_id);
    this.setState({
      dataCxcDetail: response,
      // isOpenModalAddCuota: false,
      // isOpenModalEditCuota: false,
      // isOpenModalCxcEditDetalle: false,
      // isOpenModalCxcDetalle: false,
      loading: false,
      msg_error: "",
    });
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();

    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear())
        result = currentYear.getFullYear();
    }
    this.setState({
      year: result,
    });
  }

  SaveRP_rpagoDetail() {
    const props = this.state.dataFormRPagoD;
    const propsRPago = this.state.dataFormRPago;
    if (props.rpd_tpago.length > 0 && props.rpd_monto.length > 0) {
      const body = {
        rpd_rpago:
          propsRPago.per_id +
          propsRPago.per_cedula.replace(/\D/g, "")+ propsRPago.reg_id,
          rpd_secuencia:
          propsRPago.per_id +
          propsRPago.per_cedula.replace(/\D/g, "")+ propsRPago.num_f,
        rpd_monto: props.rpd_monto,
        rpd_tpago: props.rpd_tpago,
        rpd_date: moment(new Date()).format("YYYY-MM-DD"),
        rpd_cxc: this.state.rpd_cxc,
      };

      postRPagoDetail(body);
      this.setState({
        loading: true,
        isOpenModalSaved: true,
        msg_error3: "",
        isOpenModalAddCxC:false
      });
      setTimeout(() => {
        this.fetchRPagoDetail();
      }, 1500);
    } else {
      this.setState({ msg_error3: "Campos vacios" });
    }
  }

  async getTPago() {
    const response = await getTpago();
    var datas = [];
    response.map((data,i)=>{
      if(data.tp_id!=="1" && data.tp_id!=="2"&& data.tp_id!=="5" && data.tp_id!=="6" && data.tp_id!=="7" && data.tp_id!=="11" ){
        datas.push(data);
      }
      
      return null
    })

    this.setState({
      dataTPago: datas,
    });
  }

  async fetchPersonList(gr_id, gr_desc, gr_alias) {
    const props = this.state;

    const response = await getPersonListByGradeByYear(gr_id, props.year);
    this.setState({
      dataPerson: response,
      dataFGrade: {
        gr_id,
        gr_desc,
        gr_alias,
      },
    });
  }

  async fetchRPagoDetail() {
    const props = this.state.dataFormRPago;
    const propsRPago = this.state.dataFormRPago;
    const response = await getRPagoDetail(
      props.per_id + props.per_cedula.replace(/\D/g, "") + + props.reg_id
    );
    var result = 0;
    response.map((data, i) => {
      if(data.rpd_secuencia===propsRPago.per_id +
        propsRPago.per_cedula.replace(/\D/g, "")+ propsRPago.num_f){
          result = Number(result) + Number(data.rpd_monto);
        }
     
      return null;
    });
    this.setState({
      dataRPagoD: response,
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        tp_desc: "", 
        rpd_secuencia:"",
        rpd_cxc:"",
      },
      dataFormRPago: {
        ...this.state.dataFormRPago,
        rp_pagoTotal: Number(result).toFixed(2).toString(),
      },
      loading: false,
      isOpenModalSaved: false,
    });
  }

  setMetodoPago = (rp_metodop: string) => {
    this.setState({
      dataFormRPago: {
        ...this.state.dataFormRPago,
        rp_metodop,
      },
    });
  };

  toggleDropdown() {
    this.setState((prevState) => ({
      isOpenDropdown: !prevState.isOpenDropdown,
    }));
  }

  componentDidMount() {
    this.getTPago();
    this.fetchGradeAsig();
  }

  async handlerSearchPerson() {
    const props = this.state.dataFormRPago;
    if (props.per_cedula.length > 0) {
      const response = await getPersonByCedulaRPago(props.per_cedula);

      if (response.existe !== "no") {
        this.setState({
          dataFormRPago: {
            ...this.state.dataFormRPago,
            num_f: response[0].num_f,
            per_id: response[0].per_id,
            per_cedula: response[0].per_cedula,
            per_name: response[0].per_name + ` ` + response[0].per_lastname,
            reg_id: response[0].reg_id,
          },
          msg_error: "",
        });
        this.handlerSearchCuenta(response[0].reg_id);
        this.fetchRPagoDetail();
      } else {
        this.setState({
          msg_error: "No existe persona con esa cedula",
        });
      }
    } else {
      this.setState({
        msg_error: "El campo cedula esta vacio",
      });
    }
  }

  onChangeRPago(e: any, rpd_tpago) {
    this.setState({
      dataFormRPagoD: {
        ...this.state.dataFormRPagoD,
        [e.target.name]: e.target.value,
        rpd_tpago,
      },
      msg_error: "",
      msg_error2: "",
      msg_error3: "",
    });
  }

  onChangeRPagoRef(e: any) {
    this.setState({
      dataFormRPago: {
        ...this.state.dataFormRPago,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
      msg_error2: "",
      msg_error3: "",
    });
  }

  onChangeRPagoCedula(e: any) {
    this.setState({
      dataFormRPagoD: {
        ...this.state.dataFormRPagoD,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
      msg_error2: "",
      msg_error3: "",
    });
  }

  onChangeDatePicker(date: any) {
    this.setState({
      dataFormRPago: {
        ...this.state.dataFormRPago,
        rp_fechapago: date,
      },
    });
  }

  setTpago({ tp_desc, rpd_tpago }) {
    this.setState({
      dataFormRPagoD: {
        ...this.state.dataFormRPagoD,
        rpd_tpago,
        tp_desc,
      },
      t_pago:rpd_tpago
    });
  }

  cancelRpago() {
    this.setState({
      dataFormRPago: {
        num_f: "",
        per_id: "",
        per_cedula: "",
        per_name: "",
        rp_metodop: "",
        rp_pagoTotal: "",
        rp_referencia: "",
        rp_fechapago: new Date().toString(),
        reg_id: "",
      },
      dataFormRPagoD: {
        rpd_id: "",
        rpd_monto: "",
        rpd_tpago: "",
        rpd_secuencia:"",
        tp_desc: "",
        rpd_cxc:"",
      },
      dataRPagoD: [],
      msg_error: "",
      msg_error2: "",
      msg_error3: "",
    });
  }

  saveRpago() {
    const props = this.state.dataFormRPago;
    if (
      props.rp_referencia.length > 0 &&
      props.per_cedula.length > 0 &&
      props.rp_metodop.length > 0 &&
      props.per_id.length > 0 &&
      Number(props.rp_pagoTotal)>0
    ) {
      const body = {
        rp_rpago: props.per_id + props.per_cedula.replace(/\D/g, "") + props.reg_id,
        rp_secuencia:
          props.per_id + props.per_cedula.replace(/\D/g, "") + props.num_f,
        rp_person: props.per_id,
        rp_pagototal: props.rp_pagoTotal,
        rp_metodo_pago: props.rp_metodop,
        rp_referencia: props.rp_referencia,
        rp_date: moment(props.rp_fechapago).format("YYYY-MM-DD"),
      };

      postRP_rpago(body);
      this.setState({
        isOpenModalSaved: true,
        dataFormRPago: {
          num_f: "",
          per_id: "",
          per_cedula: "",
          per_name: "",
          rp_metodop: "",
          rp_pagoTotal: "",
          rp_referencia: "",
          rp_fechapago: new Date().toString(),
          reg_id: "",
        },
         formMatricula: {
        cxcr_id: "",
        cxcr_registration: "",
        cxcr_tcuenta: "",
        cxcr_matricula: "",
        cxcr_mensualidad: "",
        cxcr_stado: "",
        cxcr_saldo: "",
        cxcr_status: "",
        cxcr_date: "",
        cxcr_anualidad: "",
        cxcr_s_anualidad: "",
        cxcr_saldo_cole: "",
        cxcr_anualidad_state: "",
        cxcr_debep: "",
        per_cedula:"",
        reg_grade:""
      },
          formMonto: {
        mt_id: "",
        mt_grade: "",
        mt_year: "",
        mt_mensualidad_r: "",
        mt_mensualidad_hm: "",
        mt_mensualidad_hd: "",
        mt_matricula_r: "",
        mt_matricula_hm: "",
        mt_matricula_hd: "",
        mt_plataforma: "",
        mt_laboratorio: "",
        mt_efisica: "",
        mt_otro_monto: "",
        mt_otro_desc: "",
        mt_anualidad_r: "",
        mt_anualidad_hm: "",
        mt_anualidad_hd: "",
        mt_a_plataforma: "",
        mt_a_laboratorio: "",
        mt_a_efisica: "",
        t_status: "",
        mt_a_robotica:"",
        mt_robotica:"",
      },
      dataFGrade: {
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
      },
        dataFormRPagoD: {
          rpd_id: "",
          rpd_monto: "",
          rpd_tpago: "",
          rpd_secuencia:"",
          tp_desc: "",
          rpd_cxc:"",
        },
        cxc_cobrar:[],
        dataRPagoD: [],
        msg_error: "",
        msg_error2: "",
        msg_error3: "",
      });

      setTimeout(() => {
        this.setState({
          isOpenModalSaved: false,
        });
      }, 1000);
    } else {
      this.setState({
        msg_error2:
          "El campo de pago total,referencia, metodo de pago o cedula esta vacio",
      });
    }
  }

  handlerDeleteRow(rpd_id: string) {
    const body = {
      rpd_id,
    };
    deleteRpd(body);

    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchRPagoDetail();
    }, 1000);
  }

  addPaymentCxc(t_pago, rpd_cxc) {
    this.setState((prevState) => ({
      isOpenModalAddCxC: !prevState.isOpenModalAddCxC,
      t_pago,
      rpd_cxc,
      msg_error: "",
    }));
  }

  modalAddPayment() {
    this.setState((prevState) => ({
      isOpenModalAddCxC: !prevState.isOpenModalAddCxC,
      t_pago: "",
      msg_error: "",
    }));
  }

  handlerModalSaved() {
    this.setState((prevState) => ({
      isOpenModalSaved: !prevState.isOpenModalSaved,
    }));
  }

  handlerOpenLista() {
    this.setState((prevState) => ({ 
      dataFGrade: {
        gr_id: "",
        gr_alias: "",
        gr_desc: "",
      },
      dataPerson:[],
      isOpenModalLista: !prevState.isOpenModalLista,
    }));
  }

  handlerSetPerson(row: any) {
    this.setState({
      dataFormRPago: {
        ...this.state.dataFormRPago,
        per_id: row.per_id,
        per_cedula: row.per_cedula,
        per_name: row.per_name,
      },
      isOpenModalLista: false,
    });
  }

  setPerson(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Button
            className="txt-underline w-100"
            onClick={() => this.handlerSetPerson(row)}
          >
            Selecionar
          </Button>
        </Col>
      </Row>
    );
  }

  async fetchGradeAsig() {
    const response = await getGrades();

    this.setState({
      dataGrades: response,
      msg_error: "",
    });
  }

  setGroup({ gr_id, gr_desc, gr_alias }) {
    this.fetchPersonList(gr_id, gr_desc, gr_alias);
  }

  handlerActiveTab(id: string) {
    this.setState({
      activeTab: id,
    });
  }

  onChangeData(e: any) {
    this.setState({
      formMatricula: {
        ...this.state.formMatricula,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  setDataEstadoMatricula(target: string) {
    const body = {
      cxcr_id: this.state.formMatricula.cxcr_id,
      cxcr_stado: target,
    };
    update_stado_matricula(body);
    this.setState({
      formMatricula: {
        ...this.state.formMatricula,
        cxcr_stado: target,
      },
      msg_error: "",
    });
  }

  setDataEstadoMensualidad(cxc_stado: string, cxc_id: any) {
    const body = {
      cxc_id,
      cxc_stado,
    };

    update_stado_mensualidad(body);
    this.fetchCxc(this.state.formMatricula.cxcr_registration);
  }

  setMorosidad(cxc_morostado: string, cxc_id: any) {
    const body = {
      cxc_id,
      cxc_morostado,
    };

    update_stado_morosidad(body);
    this.fetchCxc(this.state.formMatricula.cxcr_registration);
  }

  setDataEstado(target: string) {
    this.setState({
      formMatricula: {
        ...this.state.formMatricula,
        cxcr_stado: target,
      },
      msg_error: "",
    });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalSaved && (
          <ModalSaved
            isOpen={props.isOpenModalSaved}
            toggle={this.handlerModalSaved}
          />
        )}

        {props.isOpenModalLista && (
          <ModalListaPersonConta
            dataPerson={props.dataPerson}
            setPerson={this.setPerson}
            toggleClose={this.handlerOpenLista}
            isOpen={props.isOpenModalLista}
            title="Selecionar persona"
            dataFGrade={props.dataFGrade}
            dataGroup={props.dataGrades}
            setGroup={this.setGroup}
          />
        )}

        {props.isOpenModalAddCxC && (
          <ModalAddCXC
            dataFMatricula={props.dataFormRPagoD}
            onChange={this.onChangeRPago}
            msg_error={props.msg_error}
            toggleSave={this.SaveRP_rpagoDetail}
            toggleClose={this.modalAddPayment}
            isOpen={props.isOpenModalAddCxC}
            title="Añadir pago"
            t_pago={props.t_pago}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Registrar Pagos</h3>
              </Label>
            </Col>

            <Col sm={12}>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: props.activeTab === "1" })}
                    onClick={() => {
                      this.handlerActiveTab("1");
                    }}
                  >
                    Estudiantes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: props.activeTab === "2" })}
                    onClick={() => {
                      this.handlerActiveTab("2");
                    }}
                  >
                    Otros
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={props.activeTab} className="w-100">
                <TabPane tabId="1">
                  <React.Fragment>
                    <Row>
                      <Col sm={12} className="text-center">
                        <PaginationHeaderYear
                          year={props.year}
                          changeHeader={this.changeHeader}
                        />
                      </Col>
                      <Col sm={4}>
                        <FormGroup>
                          <Label className="font-weight-bold">Cliente : </Label>
                          <Input
                            type="text"
                            name="per_cedula"
                            onChange={this.onChangeRPagoCedula}
                            value={props.dataFormRPago.per_cedula}
                            id="per_cedula"
                            placeholder="Cedula"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={4}>
                        <Button
                          color="success"
                          className="mr-2 button-pr"
                          onClick={() => this.handlerSearchPerson()}
                        >
                          Buscar
                        </Button>
                        {
                          props.dataFormRPago.rp_pagoTotal.length>0?                      <Button
                          color="info"
                          className="mr-2 button-pr"
                          disabled
                        >
                          Lista
                        </Button>:                      <Button
                          color="info"
                          className="mr-2 button-pr"
                          onClick={() => this.handlerOpenLista()}
                        >
                          Lista
                        </Button>

                        }
  
                      </Col>
                      <Col sm={4}></Col>
                      <Col sm={12} className="text-left h-40px">
                        {props.msg_error.length > 0 ? (
                          <Label className="font-weight-bold  l-color-danger">
                            {props.msg_error}
                          </Label>
                        ) : props.dataFormRPago.per_name.length > 0 ? (
                          <Label className="font-weight-bold">{`Nombre : ${props.dataFormRPago.per_name}    Cedula:  ${props.dataFormRPago.per_cedula}`}</Label>
                        ) : null}
                      </Col>
                      {props.cxc_cobrar.length > 0 ? (
                        <React.Fragment>
                          <Col xs={12} className="text-center info">
                            <Label className="font-weight-bold">
                              MATRICULA
                            </Label>
                          </Col>
                          <Col xs={2} className="text-left">
                            <Label className="font-weight-bold">Monto:</Label>
                            <br></br>
                            <FormGroup>
                              <Input
                                type="number"
                                name="cxcr_matricula"
                                onChange={this.onChangeData}
                                value={Number(
                                  props.formMatricula.cxcr_matricula
                                ).toFixed(2)}
                                id="cxcr_matricula"
                                placeholder="B/."
                                disabled
                              />
                            </FormGroup>
                          </Col>
                          <Col xs={2} className="text-left">
                            <Label className="font-weight-bold">
                              Cancelado:
                            </Label>
                            <br></br>
                            <Input
                              type="number"
                              name="cxcr_saldo"
                              disabled
                              onChange={this.onChangeData}
                              value={
                                props.formMatricula.cxcr_stado === "1"
                                  ? GET_SUM_T_PAGO(
                                      props.dataRPagoD,
                                      "2",
                                      false,
                                      null
                                    ).toFixed(2)
                                  : "B/."
                              }
                              id="cxcr_saldo"
                              placeholder="B/."
                              min={0}
                              max={1000}
                            />
                          </Col>
                          <Col xs={2} className="text-left">
                            <Label className="font-weight-bold">
                              Por pagar:
                            </Label>
                            <br></br>
                            <Input
                              className="w-150px"
                              type="number"
                              name="cxcr_saldo"
                              value={
                                props.formMatricula.cxcr_stado === "1"
                                  ? (
                                      Number(
                                        props.formMatricula.cxcr_matricula
                                      ) -
                                      Number(
                                        GET_SUM_T_PAGO(
                                          props.dataRPagoD,
                                          "2",
                                          false,
                                          null
                                        )
                                      )
                                    ).toFixed(2)
                                  : "B/."
                              }
                              id="cxcr_saldo"
                              placeholder="B/."
                              min={0}
                              max={1000}
                              disabled
                            />
                          </Col>
                          <Col xs={3} className="text-center">
                            <Label className="font-weight-bold">
                              Debe pagar:
                            </Label>
                            <br></br>
                            <ButtonGroup>
                              <Button
                                color="primary"
                                outline
                                onClick={() => this.setDataEstadoMatricula("1")}
                                active={props.formMatricula.cxcr_stado === "1"}
                              >
                                SI
                              </Button>
                              <Button
                                color="success"
                                outline
                                onClick={() => this.setDataEstadoMatricula("2")}
                                active={props.formMatricula.cxcr_stado === "2"}
                              >
                                NO
                              </Button>
                            </ButtonGroup>
                          </Col>
                          <Col xs={3} className="text-center">
                            {props.formMatricula.cxcr_stado === "1" ? (
                              <Button
                                color="primary"
                                className="mt-4"
                                onClick={() => this.addPaymentCxc("2",props.formMatricula.cxcr_id)}
                              >
                                Incluir pago
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                className="mt-4"
                                outline
                                disabled
                              >
                                Incluir pago
                              </Button>
                            )}
                          </Col>

                          <Col x={12}>
                            {props.cxc_cobrar.length > 0 ? (
                              <BODY_CUENTAS
                                props={props}
                                setDebePagar={this.setDataEstadoMensualidad}
                                setMorosidad={this.setMorosidad}
                                openAddPago={this.addPaymentCxc}
                              />
                            ) : null}
                          </Col>
                        </React.Fragment>
                      ) : null}
                    </Row>
                  </React.Fragment>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                  <Col sm={2}>
            </Col>
            <Col sm={3}>
              <FormGroup>
                <Label className="font-weight-bold">Tipo de pago :</Label>

                <Dropdown isOpen={props.isOpenDropdown} toggle={this.toggleDropdown}>
                  <DropdownToggle className="w-100" caret>
                    {props.dataFormRPagoD.tp_desc ? props.dataFormRPagoD.tp_desc : "Seleccionar"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {props.dataTPago.map((data, i) => (
                      <DropdownItem onClick={() => this.setTpago({ tp_desc: data.tp_desc, rpd_tpago: data.tp_id })} key={data.tp_id}>
                        {data.tp_desc}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </FormGroup>
            </Col>
            <Col sm={3}>
            <FormGroup>
                <Label className="font-weight-bold">Monto</Label>
                <Input
                  type="number"
                  name="rpd_monto"
                  onChange={(e) => {this.onChangeRPago(e,props.t_pago)}}
                  value={props.dataFormRPagoD.rpd_monto}
                  id="rpd_monto"
                  placeholder="B/. Monto"
                  min={0}
                  max={1000}
                  step="1"
                />
              </FormGroup>
            </Col>
            <Col sm={2}>
            <Button
                          color="success"
                          className="mr-2 button-pr"
                          onClick={() => this.SaveRP_rpagoDetail()}
                        >
                          Guardar
                        </Button>
            </Col>
            <Col sm={2}>
            </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
          <Row className="mt-5">
            {props.cxc_cobrar.length > 0 ? (
              <React.Fragment>
                <Col sm={2} className="text-left">
                  <FormGroup>
                    <Label className="font-weight-bold">Pago Total</Label>
                    <Input
                      type="number"
                      name="rp_pagoTotal"
                      onChange={this.onChangeRPagoCedula}
                      value={props.dataFormRPago.rp_pagoTotal}
                      id="rp_pagoTotal"
                      placeholder="B/. Pago Total"
                      min={0}
                      max={1000}
                      step="1"
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <Label className="font-weight-bold">Metodo de pago:</Label>
                  <br></br>
                  <ButtonGroup>
                    <Button
                      outline
                      color="primary"
                      onClick={() => this.setMetodoPago("1")}
                      active={
                        props.dataFormRPago.rp_metodop === "1" ? true : false
                      }
                    >
                      ACH
                    </Button>
                    <Button
                      outline
                      color="danger"
                      onClick={() => this.setMetodoPago("2")}
                      active={
                        props.dataFormRPago.rp_metodop === "2" ? true : false
                      }
                    >
                      DEPOSITO
                    </Button>
                    <Button
                      outline
                      color="secondary"
                      onClick={() => this.setMetodoPago("3")}
                      active={
                        props.dataFormRPago.rp_metodop === "3" ? true : false
                      }
                    >
                      EFECTIVO
                    </Button>
                    <Button
                      outline
                      color="danger"
                      onClick={() => this.setMetodoPago("4")}
                      active={
                        props.dataFormRPago.rp_metodop === "4" ? true : false
                      }
                    >
                      TARJETA
                    </Button>
                    <Button
                      outline
                      color="success"
                      onClick={() => this.setMetodoPago("5")}
                      active={
                        props.dataFormRPago.rp_metodop === "5" ? true : false
                      }
                    >
                      BONO
                    </Button>
                  </ButtonGroup>
                </Col>
                <Col sm={2}>
                  <Label className="font-weight-bold">Referencia:</Label>
                  <br></br>
                  <Input
                    type="text"
                    name="rp_referencia"
                    onChange={this.onChangeRPagoRef}
                    value={props.dataFormRPago.rp_referencia}
                    id="rp_referencia"
                    placeholder="Referencia"
                />
                </Col>
                <Col sm={2}>
                  <Label className="font-weight-bold mr-2">
                    Fecha de pago:
                  </Label>
                  <br></br>
                  <DatePicker
                    selected={new Date(props.dataFormRPago.rp_fechapago)}
                    onChange={this.onChangeDatePicker}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="form-control w-100"
                  />
                </Col>
                <Col xs={12}>
                  {props.msg_error2.length > 0 ? (
                    <Label className="l-color-danger">
                      {props.msg_error2}{" "}
                    </Label>
                  ) : null}
                </Col>
                <Col sm={12} className="text-right">
                  <Button
                    color="danger"
                    className="mr-2 button-pr"
                    onClick={() => this.cancelRpago()}
                  >
                    Cancelar
                  </Button>
                  <Button
                    color="success"
                    className="mr-2 button-pr"
                    onClick={() => this.saveRpago()}
                  >
                    Registrar pago
                  </Button>
                </Col>
              </React.Fragment>
            ) : null}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Rpagos;
